import { Button, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import './ServicesPage.css'
import { useOutletContext } from 'react-router-dom';

export default function ServicesPage({setToken}) {
  const [firstTime, setFirstTime] = useState(true);
  const [isMobile, loading] = useOutletContext();

  useEffect(() => {
    if(firstTime)
    {
      
    }
    setFirstTime(false);
  }, [firstTime]);

  return (
    <>
        <Stack alignContent={"left"} style={{padding: "0 2rem", margin: "auto", width: "90%"}}>
            <div style={{textAlign: "center"}}>
              <h2><b>SERVIZI</b></h2></div>

              {!isMobile ? 
              <>
              <div className="row">
                <div className="column">
                    <b style={{fontSize: "1.25rem"}}><u>PREZZI</u></b>
                    <p>Il Cinema Aurora propone l’accesso a tutti i Film con i seguenti prezzi:</p>
                    <p><strong style={{fontSize: "1rem"}}>Intero: € 8,00</strong></p>
                    <p><strong style={{fontSize: "1rem"}}>Ridotto</strong> (minori di 14 anni): <strong>€ 6,00</strong></p>
                    <p><strong style={{fontSize: "1rem"}}>Spettacoli: € 10,00</strong></p>
                </div>
                <div className="column"><img style={{padding: "0 0 0 0"}} src={`${process.env.PUBLIC_URL}/images/services/biglietti.jpg`}/></div>
              </div><br/>
              <div className="row">
              <div className="column"><img style={{padding: "0rem 2rem 0 0"}} src={`${process.env.PUBLIC_URL}/images/services/ristoro.jpg`}/></div>
                <div className="column">
                <b style={{fontSize: "1.25rem"}}><u>RISTORO</u></b> 
                    <p>Adiacente al cinema, troverai diversi servizi, tra cui un'area giochi dedicata alle famiglie e spazi dove sarà possibile acquistare alimenti da consumare in sala.</p>
                </div>
              </div><br/>
              <div className="row">
               
                    <b style={{fontSize: "1.25rem"}}><u>AFFITTO SALA</u></b>
                    <p>Organizzi eventi o hai bisogno di un ambiente ben fornito e organizzato per convegni o incontri? Il Cinema 
                    Aurora è a tua disposizione! Per maggiori informazioni contattaci oppure scarica il modulo di richiesta e il regolamento.</p>
                    <Button variant='contained'>Regolamento</Button>&nbsp;&nbsp;<Button variant='contained'>Modulo Affitto Sala</Button>
                <br/><br/>
                <div style={{display: "flex", gap:"1rem" }}>
                  <img style={{margin: "auto", width: "50%"}} src={`${process.env.PUBLIC_URL}/images/services/cinema_1.jpg`}/>
                  <img style={{margin: "auto", width: "50%"}} src={`${process.env.PUBLIC_URL}/images/services/cinema_2.jpg`}/>
                  </div>
              </div></> : 
              <>
                <Stack>
                  <img src={`${process.env.PUBLIC_URL}/images/services/biglietti.jpg`}/><br/>
                  <b style={{fontSize: "1.25rem"}}><u>PREZZI</u></b>
                    <p>Il Cinema Aurora propone l’accesso a tutti i Film con i seguenti prezzi:</p>
                    <p style={{margin: "0"}}><strong style={{fontSize: "1rem"}}>Intero: € 8,00</strong></p>
                    <p style={{margin: "0"}}><strong style={{fontSize: "1rem"}}>Ridotto</strong> (minori di 14 anni): <strong>€ 6,00</strong></p>
                    <p style={{margin: "0"}}><strong style={{fontSize: "1rem"}}>Spettacoli: € 10,00</strong></p>
                </Stack>
                    <hr style={{width:"100%"}}/><br/>
                <Stack> 
                    <img src={`${process.env.PUBLIC_URL}/images/services/ristoro.jpg`}/><br/>
                    <b style={{fontSize: "1.25rem"}}><u>RISTORO</u></b> 
                    <p>Adiacente al cinema, troverai diversi servizi, tra cui un'area giochi dedicata alle famiglie e spazi dove sarà possibile acquistare alimenti da consumare in sala.</p>
                </Stack>
                  <hr style={{width:"100%"}}/><br/>
                <Stack> 
                    <b style={{fontSize: "1.25rem"}}><u>AFFITTO SALA</u></b>
                    <p>Organizzi eventi o hai bisogno di un ambiente ben fornito e organizzato per convegni o incontri? Il Cinema 
                    Aurora è a tua disposizione! Per maggiori informazioni contattaci oppure scarica il modulo di richiesta e il regolamento.</p>
                    <br/>
                    <Button variant='contained'>Regolamento</Button><br/><Button variant='contained'>Modulo Affitto Sala</Button><br/><br/>
                    <img style={{width: "100%"}} src={`${process.env.PUBLIC_URL}/images/services/cinema_1.jpg`}/><br/> 
                    <img style={{width: "100%"}} src={`${process.env.PUBLIC_URL}/images/services/cinema_2.jpg`}/>
                </Stack>
              
              </>}
            
          </Stack>
    </>
  );
}
